export default __webpack_public_path__ + "teams-mobile-top.88fc75.png";